import { render, staticRenderFns } from "./EndCard.vue?vue&type=template&id=66d136a6&scoped=true"
import script from "./EndCard.vue?vue&type=script&lang=js"
export * from "./EndCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d136a6",
  null
  
)

export default component.exports